var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconButtonLightAuto = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 24,
  fill: "none",
  viewBox: "1 10 40 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "m26.233 11.091-7 18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M27.086 25h.984l3.375-9.29.22-.608q.108-.29.187-.586h.085q.086.296.188.586.101.288.219.609L35.734 25h1.047l-4.336-11.453h-1.054zm1.594-3.18h6.445l-.328-.82h-5.781zM7.943 14.823l-1.05-1.044-.822.823 1.044 1.044zm-3.36 3.302h1.75v1.167h-1.75zm5.834-5.804h1.166v1.72h-1.166zm4.69 1.455.82.821-1.043 1.044-.821-.821zm-1.05 8.817 1.044 1.05.822-.822-1.05-1.044zm1.61-4.468h1.75v1.167h-1.75zM11 15.208c-1.93 0-3.5 1.57-3.5 3.5 0 1.931 1.57 3.5 3.5 3.5s3.5-1.569 3.5-3.5c0-1.93-1.57-3.5-3.5-3.5m0 5.834a2.333 2.333 0 1 1-.001-4.666 2.333 2.333 0 0 1 0 4.666zm-.583 2.333h1.166v1.72h-1.166zm-4.346-.56.822.823 1.044-1.05-.822-.823z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconButtonLightAuto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-button-light-auto.b17b810fa6f3c70195e5960e457a4a86.svg";